module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "take-place column activity-container"
  }, [(_vm.addSearch) ? _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label form-ui default-form-ui"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Rechercher")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "search",
      "name": "name"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, function($event) {
        return _vm.onFilterTextBoxChanged()
      }]
    }
  })]) : _vm._e(), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "table-custom column",
    attrs: {
      "gridReady": _vm.onReady,
      "gridOptions": _vm.options,
      "columnDefs": _vm.columnsComputed,
      "rowData": _vm.rows,
      "enableSorting": true
    }
  }), _vm._v(" "), (_vm.showGrid && _vm.options.pagination) ? _c('div', {
    staticClass: "table-pagination"
  }, [_c('div', [_vm._v("Montrer "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paginationPageSize),
      expression: "paginationPageSize"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.paginationPageSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paginationPageSize = $event.target.value
      }
    }
  }), _vm._v(" éléments par page")]), _vm._v(" "), _c('div', [_vm._v("Page "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    staticClass: "input-page",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a0c4999"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/ag-table.vue
// module id = 1152
// module chunks = 0